module.exports = __webpack_public_path__ + "static/media/camera.4dc3d1b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/camera.svg
// module id = 511
// module chunks = 0